export class Task {
  constructor(isRunning: false);
  constructor(isRunning: true, runningText: string);
  constructor(readonly isRunning: true | false, readonly runningText?: string){
  }

  static readonly none = new Task(false);
}
